import { TopicLiteModel } from '@eloomi/eloomi-learning-persona-client/1.0';
import { Mutations } from 'vuex-smart-module';

import { CourseTopic, ICoursePlayerCourse, UserTopic } from '../models';
import { UserCoursesState } from './state';
import { SkillResponse } from '@eloomi/eloomi-learning-persona-client/1.0/models/skill-response';

export class UserCoursesMutations extends Mutations<UserCoursesState> {
    public setActiveCourse(course: ICoursePlayerCourse) {
        this.state.activeCourse = course;
    }

    public unsetActiveCourse() {
        this.state.activeCourse = null;
        this.state.activeChapterId = null;
        this.state.activePageId = null;
    }

    public setActiveChapterId(chapterId: number) {
        this.state.activeChapterId = chapterId;
    }

    public setActivePageId(pageId: number) {
        this.state.activePageId = pageId;
    }

    public markActivePageAsCompleted() {
        const activeChapter = this.state.activeCourse?.chapters.find(
            chapter => chapter.id === this.state.activeChapterId
        );
        const activePage = activeChapter?.pages.find(page => page.id === this.state.activePageId);

        if (activePage !== undefined) {
            activePage.is_completed = true;
        }
    }

    public setSelectedCourseTopics(data: UserTopic[] | CourseTopic | TopicLiteModel) {
        if (Array.isArray(data)) {
            this.state.selectedTopics = data;
        } else {
            this.state.selectedTopics.push({
                topic_name: data.name,
                topic_id: data.id,
                assigned_courses_count: 0,
                assigned_playlists_count: 0,
            });
        }
    }

    public setSelectedCourseSkills(data: SkillResponse[]) {
        this.state.selectedSkills = data;
    }

    public removeTopicFilter(item: UserTopic) {
        this.state.selectedTopics = this.state.selectedTopics.filter(el => {
            return el.topic_id !== item.topic_id;
        });
    }

    public removeSkillFilter(item: SkillResponse) {
        this.state.selectedSkills = this.state.selectedSkills.filter(el => {
            return el.id !== item.id;
        });
    }

    public clearFilters() {
        this.state.selectedTopics = [];
        this.state.selectedSkills = [];
    }
}
